import React, { useState, useEffect } from 'react';
import { ArrowRight, MessageCircle, Share2, Users, Target, CheckCircle, Heart, Award, Briefcase, Mail } from 'lucide-react';
import { mockData } from '../data/mock';
import { profileAPI } from '../services/api';
import api, { contactAPI } from '../services/api';

const Home = () => {
  const { services } = mockData; // Still use mock services for now
  const [profileInfo, setProfileInfo] = useState({
    name: "Stefan Hay",
    title: "Freelancer für Digitale Kommunikation, Social Media & Employer Branding", 
    description: "Ich helfe Unternehmen dabei, ihre digitale Präsenz zu stärken und authentische Arbeitgebermarken zu entwickeln. Von Start-ups bis zu Großkonzernen – gemeinsam entwickeln wir Kommunikationsstrategien und Haylights, die begeistern und verbinden.",
    image: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAGQAZADASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAcI/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AlgCdNlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/2Q==",
    linkedin: "https://www.linkedin.com/in/stefan-hay-de/",
    email: "stefan@haylights.de"
  }); 
  const [profileLoaded, setProfileLoaded] = useState(true); // Start with true since we have data
  // Contact form removed - using direct contact methods only

  useEffect(() => {
    // Use local mock data directly instead of trying to load from backend
    const loadProfile = async () => {
      try {
        // Directly use the corrected mock data
        setProfileInfo(mockData.personalInfo);
        setProfileLoaded(true);
        console.log('Using updated local mock data');
      } catch (error) {
        console.error('Error loading profile:', error);
        // Even fallback uses the same corrected data
        const localProfileData = {
          name: "Stefan Hay",
          title: "Freelancer für Digitale Kommunikation, Social Media & Employer Branding",
          description: "Ich helfe Unternehmen dabei, ihre digitale Präsenz zu stärken und authentische Arbeitgebermarken zu entwickeln. Von Start-ups bis zu Großkonzernen – gemeinsam entwickeln wir Kommunikationsstrategien und Haylights, die begeistern und verbinden.",
          image: "https://customer-assets.emergentagent.com/job_hay-comms-site/artifacts/fy8fzcbv_Screenshot%202025-07-18%20132114.jpg",
          linkedin: "https://www.linkedin.com/in/stefan-hay-de/",
          email: "stefan@haylights.de"
        };
        setProfileInfo(localProfileData);
        setProfileLoaded(true);
      }
    };

    loadProfile();
  }, []);

  const iconMap = {
    MessageCircle,
    Share2,
    Users,
    Target
  };

  const stats = [
    { number: '100+', label: 'Erfolgreiche Projekte' },
    { number: '50+', label: 'Zufriedene Kunden' },
    { number: '10+', label: 'Jahre Erfahrung' }
  ];

  const values = [
    {
      icon: Heart,
      title: 'Authentizität',
      description: 'Echte Kommunikation, die von Herzen kommt und authentisch wirkt.'
    },
    {
      icon: Award,
      title: 'Qualität',
      description: 'Höchste Standards in jedem Projekt und bei jeder Zusammenarbeit.'
    },
    {
      icon: Briefcase,
      title: 'Expertise',
      description: 'Fundiertes Wissen und kontinuierliche Weiterbildung.'
    }
  ];

  // Contact form functions removed - using direct mailto and LinkedIn links

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Home Section */}
      <section id="home" className="section relative min-h-screen flex items-center justify-center pb-20 pt-40 md:py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-violet-500/10 to-cyan-500/10"></div>
        <div className="absolute top-20 right-20 w-40 h-40 bg-gradient-to-br from-violet-500/20 to-cyan-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-60 h-60 bg-gradient-to-br from-purple-500/20 to-turquoise-500/20 rounded-full blur-3xl"></div>
        
        <div className="container relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="animate-fadeInLeft lg:pt-8 pt-8">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Digitale Kommunikation, <span className="text-gradient">die begeistert.</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                {profileLoaded && profileInfo?.description ? profileInfo.description : 'Ihr Partner für professionelle digitale Kommunikation...'}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
                  className="btn btn-primary"
                >
                  Kontakt
                  <ArrowRight size={20} />
                </button>
                <button 
                  onClick={() => document.querySelector('#services').scrollIntoView({ behavior: 'smooth' })}
                  className="btn btn-secondary"
                >
                  Services ansehen
                </button>
              </div>
            </div>
            
            <div className="animate-fadeInRight">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-violet-500 to-cyan-500 rounded-full blur-2xl opacity-30"></div>
                <img
                  src="https://customer-assets.emergentagent.com/job_hay-comms-site/artifacts/fy8fzcbv_Screenshot%202025-07-18%20132114.jpg"
                  alt="Stefan Hay - Freelancer für Digitale Kommunikation"
                  className="relative z-10 w-96 h-96 object-cover rounded-full mx-auto shadow-2xl border-4 border-gray-700"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section - Moved before Services */}
      <section id="about" className="section relative">
        <div className="absolute inset-0 bg-gradient-to-r from-violet-500/10 to-cyan-500/10"></div>
        <div className="absolute top-20 right-20 w-40 h-40 bg-gradient-to-br from-violet-500/20 to-cyan-500/20 rounded-full blur-3xl"></div>
        
        <div className="container relative z-10">
          <div className="text-center mb-16 animate-fadeInUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Über <span className="text-gradient">mich</span>
            </h2>
            <div className="max-w-4xl mx-auto">
              <div className="text-xl text-gray-300 leading-relaxed space-y-6 text-center">
                <p className="text-3xl font-light mb-8">
                  Mit über 10 Jahren Erfahrung in der digitalen Kommunikation entwickle ich maßgeschneiderte Strategien für Unternehmen jeder Größe.
                </p>
                
                <p className="text-lg mb-6">
                  Meine Leidenschaft gilt der Verbindung von strategischem Denken und kreativer Umsetzung. Dabei liegt mein Fokus auf nachhaltigen Lösungen, die echte Ergebnisse erzielen.
                </p>
                
                <p className="text-lg mb-12">
                  Von der Konzeption bis zur Umsetzung begleite ich Sie durch den gesamten Prozess der digitalen Transformation Ihrer Kommunikation.
                </p>
              </div>
            </div>
          </div>

          {/* Warum mit mir arbeiten? Sektion */}
          <div className="bg-gray-800/30 rounded-2xl p-8 backdrop-blur-sm border border-gray-700/50 mb-16">
            <h3 className="text-3xl font-bold mb-8 text-center">
              <span className="text-gradient">Warum mit mir arbeiten?</span>
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Award size={32} color="white" />
                </div>
                <h4 className="text-xl font-semibold text-violet-400 mb-3">Strategischer Ansatz</h4>
                <p className="text-gray-300 leading-relaxed">Datenbasierte Entscheidungen und messbare Ergebnisse für nachhaltigen Erfolg.</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Heart size={32} color="white" />
                </div>
                <h4 className="text-xl font-semibold text-cyan-400 mb-3">Kreative Exzellenz</h4>
                <p className="text-gray-300 leading-relaxed">Innovative Lösungen mit Fokus auf Zielgruppenrelevanz und Authentizität.</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-violet-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Users size={32} color="white" />
                </div>
                <h4 className="text-xl font-semibold text-violet-400 mb-3">Persönliche Betreuung</h4>
                <p className="text-gray-300 leading-relaxed">Direkter Kontakt und individuelle Projektbegleitung auf Augenhöhe.</p>
              </div>
            </div>

            {/* Stats Section inside the box */}
            <div className="border-t border-gray-600/30 pt-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center animate-fadeInUp" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="text-2xl md:text-3xl font-bold text-gradient mb-2">{stat.number}</div>
                    <div className="text-gray-300 text-sm">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Values Section */}
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold mb-8">
              Meine <span className="text-gradient">Werte</span>
            </h3>
            <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
              Diese Grundprinzipien leiten meine Arbeit und prägen jede Kundenbeziehung.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-items-center md:justify-items-start">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div 
                  key={index} 
                  className="animate-fadeInUp max-w-sm w-full text-center md:text-left"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* Mobile: Stacked layout with centered icon */}
                  <div className="block md:hidden mb-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500 flex items-center justify-center mx-auto mb-3">
                      <Icon size={24} color="white" />
                    </div>
                    <h3 className="text-xl font-semibold text-center">{value.title}</h3>
                  </div>
                  
                  {/* Desktop: Side-by-side layout */}
                  <div className="hidden md:flex items-start mb-4">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500 flex items-center justify-center mr-4">
                      <Icon size={24} color="white" />
                    </div>
                    <h3 className="text-xl font-semibold">{value.title}</h3>
                  </div>
                  
                  <p className="text-gray-300">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="section relative">
        <div className="absolute inset-0 bg-gradient-to-r from-violet-500/10 to-cyan-500/10"></div>
        <div className="absolute top-20 right-20 w-40 h-40 bg-gradient-to-br from-violet-500/20 to-cyan-500/20 rounded-full blur-3xl"></div>
        
        <div className="container relative z-10">
          <div className="text-center mb-16 animate-fadeInUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Meine <span className="text-gradient">Services</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Von der strategischen Planung bis zur kreativen Umsetzung – 
              ich biete ganzheitliche Lösungen für Ihre digitale Kommunikation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {services.map((service, index) => {
              const Icon = iconMap[service.icon];
              return (
                <div
                  key={service.id}
                  className="group bg-gray-900/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-8 hover:bg-gray-800/50 transition-all duration-500 transform hover:scale-105 animate-fadeInUp flex flex-col h-full"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex items-center mb-6">
                    <div 
                      className="w-12 h-12 rounded-lg flex items-center justify-center mr-4"
                      style={{ backgroundColor: service.color }}
                    >
                      <Icon size={24} color="white" />
                    </div>
                    <h3 className="text-xl font-semibold group-hover:text-white transition-colors h-7 flex items-center">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-gray-300 mb-6 group-hover:text-gray-200 transition-colors leading-relaxed h-24 flex items-start">
                    {service.description}
                  </p>
                  <div className="flex-grow flex flex-col justify-end">
                    <ul className="space-y-2">
                      {service.features.slice(0, 3).map((feature, idx) => (
                        <li key={idx} className="flex items-start text-sm text-gray-400 group-hover:text-gray-300 transition-colors">
                          <CheckCircle size={16} className="mr-2 text-green-500 flex-shrink-0 mt-0.5" />
                          <span className="leading-relaxed">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section relative">
        <div className="absolute inset-0 bg-gradient-to-r from-violet-500/10 to-cyan-500/10"></div>
        <div className="absolute top-20 right-20 w-40 h-40 bg-gradient-to-br from-violet-500/20 to-cyan-500/20 rounded-full blur-3xl"></div>
        
        <div className="container relative z-10">
          <div className="text-center mb-16 animate-fadeInUp">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="text-gradient">Kontakt</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Lassen Sie uns über Ihr Projekt sprechen. Ich freue mich auf viele Haylights und Ihre Nachricht!
            </p>
          </div>

          <div className="flex justify-center">
            {/* Centered Contact Info */}
            <div className="animate-fadeInUp max-w-2xl w-full">
              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-12">
                <h3 className="text-3xl font-bold mb-8 text-center text-gradient">Kontaktinformationen</h3>
                
                <div className="space-y-8">
                  {/* Email Contact */}
                  <div className="text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                      <Mail size={32} color="white" />
                    </div>
                    <h4 className="text-xl font-semibold mb-3 text-violet-400">E-Mail</h4>
                    <a 
                      href="mailto:stefan@haylights.de"
                      className="text-2xl font-medium text-white hover:text-violet-400 transition-colors duration-300 underline decoration-violet-500/50 hover:decoration-violet-400"
                    >
                      stefan@haylights.de
                    </a>
                    <p className="text-gray-400 mt-2">
                      Klicken Sie hier, um mir eine E-Mail zu senden.
                    </p>
                  </div>

                  {/* Divider */}
                  <div className="flex items-center">
                    <div className="flex-1 border-t border-gray-600"></div>
                    <div className="px-4 text-gray-500">oder</div>
                    <div className="flex-1 border-t border-gray-600"></div>
                  </div>
                  
                  {/* LinkedIn Contact */}
                  <div className="text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                      <Users size={32} color="white" />
                    </div>
                    <h4 className="text-xl font-semibold mb-3 text-cyan-400">LinkedIn</h4>
                    <a 
                      href="https://www.linkedin.com/in/stefan-hay-de/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-violet-600 to-cyan-600 hover:from-violet-700 hover:to-cyan-700 text-white rounded-lg font-medium transition-all duration-300 transform hover:scale-105 text-lg"
                    >
                      LinkedIn Profil besuchen
                      <ArrowRight size={20} className="ml-2" />
                    </a>
                    <p className="text-gray-400 mt-2">
                      Vernetzen Sie sich mit mir auf LinkedIn.
                    </p>
                  </div>
                </div>

                {/* Response Time Note */}
                <div className="mt-8 p-4 bg-violet-900/30 border border-violet-500/30 rounded-lg text-center">
                  <p className="text-violet-300 text-sm">
                    <strong>Antwortzeit:</strong> Ich melde mich innerhalb von 24 Stunden bei Ihnen zurück
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;